import Model  from '@/util/models';

export default class Role extends Model { 
    backend = '/rbac/role/'; 
   
    assign(items, params){                        
        return this.api.post(this.backend + 'assign', items, params); 
    }    
    
    remove(items, params){                        
        return this.api.post(this.backend + 'remove', items, params); 
    }  
    
    view(params){                        
        return this.api.post(this.backend + 'view', {}, params); 
    }  
}

